import { IntlShape } from "react-intl";
import { MessageInfo } from "@42maru/webchat";


export const getValueFromDotJoinKey = (message: MessageInfo, key: string) => {
    const keys = key.split(".");
    let currentValue: any = message;

    for (const key of keys) {
        if (!currentValue || typeof currentValue !== "object") {
            return;
        }
        currentValue = currentValue[key as keyof object];
    }
    return currentValue;
};

export const getValueFromGlobalContext = (message: MessageInfo, key: string) => {
    const value = message.context?.system?.global?.[key] ?? message.context?.global?.[key] ?? "";
    return (typeof value === "object" && "value" in value) ? value.value : value;
};

export const getTextFromResponse = (object: any, join: string = "\n"): string => {
    if (Array.isArray(object)) {
        return object.map(item => getTextFromResponse(item)).join(join);
    }
    if (!object) {
        return "";
    }
    if (typeof object === "string") {
        return object;
    }
    if (object.text) {
        return object.text;
    }
    if (object.data) {
        return getTextFromResponse(object.data);
    }
    return "";
};

export const getTextAndLabelFromResponse = (object: any, intl: IntlShape, join: string = "\n"): string => {
    if (Array.isArray(object)) {
        return object.map(item => getTextAndLabelFromResponse(item, intl)).join(join);
    }
    if (!object) {
        return "";
    }
    if (typeof object === "string") {
        return object;
    }
    if (object.text) {
        if (object.buttons) {
            return `${object.text}\n[${intl.formatMessage({ id: "b0023" })}]: ${getTextAndLabelFromResponse(object.buttons, intl, ", ")}`;
        } else {
            return object.text;
        }
    }    
    if (object.label) {
        return object.label;
    }
    if (object.data) {
        if (object.data_type === "list") {
            return `[버튼]: ${getTextAndLabelFromResponse(object.data, intl, ", ")}`;
        }
        if (object.data_type === "quick_reply") {
            return `[${intl.formatMessage({ id: "b0061" })}]: ${getTextAndLabelFromResponse(object.data, intl, ", ")}`;
        }
        return getTextAndLabelFromResponse(object.data, intl);
    }
    return "";
};
